import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';
import Person from "../Person";
import WorkFlowStepLogging from "../BPMS/WorkFlowStepLogging";

export default class Remittance extends Base {
    constructor(props) {
        super(props);
        this.state = {
            enableDatePicker: false,
            controllerName: 'remittance',
            caller: props.Caller,
            refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            orderingId: this.isNull(props.OrderingId) ? this.defaultGuid() : props.OrderingId,
            io: props.IO,
            data: null,
            loading: true,
            barcode: '',
            highlightedStuffs: this.isNull(props.HighlightedStuffs) ? [] : props.HighlightedStuffs,
        };
        this.inputRefs = [];
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    resetRefs() {
        this.inputRefs = [];
    }
    handleKeyDown = (rowIndex, colIndex, e) => {
        const row = this.inputRefs[rowIndex];
        const colCount = row.length;
        const rowCount = this.inputRefs.length;

        if (colCount <= colIndex && rowCount <= rowIndex) return;

        if (e.key === "Enter") {
            e.preventDefault();
            if (colIndex + 1 < colCount) {
                //find first next active input
                if (!row[colIndex + 1]) {
                    this.handleKeyDown(rowIndex, colIndex + 1, e);
                }
                else {
                    row[colIndex + 1]?.focus();
                    if (row[colIndex + 1]?.type === "text") row[colIndex + 1]?.select();
                }
            } else if (rowIndex + 1 < rowCount) {
                if (!this.inputRefs[rowIndex + 1][0]) {
                    this.handleKeyDown(rowIndex + 1, 1, e);
                }
                else {
                    this.inputRefs[rowIndex + 1][0]?.focus();
                    if (this.inputRefs[rowIndex + 1][0]?.type === "text") this.inputRefs[rowIndex + 1][0]?.select();
                }
            }
        }

        if (e.key === "ArrowDown") {
            e.preventDefault();
            e.preventDefault();
            if (rowIndex + 1 < rowCount) {
                this.inputRefs[rowIndex + 1][colIndex]?.focus();
                if (this.inputRefs[rowIndex + 1][colIndex]?.type === "text") this.inputRefs[rowIndex + 1][colIndex]?.select();
            }
        }

        if (e.key === "ArrowUp") {
            e.preventDefault();
            if (rowIndex - 1 >= 0) {
                this.inputRefs[rowIndex - 1][colIndex]?.focus();
                if (this.inputRefs[rowIndex - 1][colIndex]?.type === "text") this.inputRefs[rowIndex - 1][colIndex]?.select();
            }
        }
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/remittance/get", {
            id: this.getCurrentFormId(),
            io: this.state.io,
            orderingId: this.state.orderingId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    window.organizationId = data.global.company.id;
                    this.state.data = data;

                    for (var i = 0; i < this.state.data.bodies.length; i++)
                        this.updateRealTimeInventory(this.state.data.bodies[i]);

                    this.state.loading = false;
                    this.updateFormula();

                    if (!this.isEmpty(this.state.highlightedStuffs)) {
                        var highlightedRowTimer = setInterval(() => {
                            clearInterval(highlightedRowTimer);
                            var t = document.getElementById('highlightedStuffs_' + this.state.highlightedStuffs[0]);
                            if (t) {
                                t.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start',
                                    inline: 'nearest',
                                });
                            }
                        }, 500);
                    }

                }
                else {
                    //this.showErorrMessage(data.message);
                    this.setState({
                        data: data,
                        loading: false
                    });
                }
            });
    }
    save(e, withDocument = false) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost("api/v1/remittance/save", {
            withDocument: withDocument,
            organizationId: this.state.data.global.company.id,
            id: this.state.data.record.id,
            manualFactor: this.state.data.record.manualFactor,
            io: this.state.data.record.io,
            number: this.state.data.record.number,
            description: this.state.data.record.description,
            date: (this.state.enableDatePicker === true ? this.convertMomentToDb(this.state.data.record.date) : this.state.data.record.dateString),
            personId: this.state.data.record.personId,
            type: this.state.data.record.type,
            personMoeinAccountId: this.state.data.record.personMoeinAccountId,
            warehouseId: this.state.data.record.warehouseId,
            warehouseId2: this.state.data.record.warehouseId2,
            orderingId: this.state.data.record.orderingId,
            factorId: this.state.data.record.factorId,
            bodies: this.state.data.bodies,
            attachments: this.state.data.attachments,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {

                    if (this.state.data.record.io == 3) {
                        this.showSuccessMessage("جابجایی بین انبارها با موفقیت انجام پذیرفت");

                        if (this.state.refreshCallerAfterSave)
                            this.state.caller.refreshData(null, "list", "json", (this.state.data.record.id === this.getDefaultGuid() ? true : false));

                        this.closeMe();
                    }

                    if (this.state.data.record.io == 2) {
                        this.showSuccessMessage("حواله انبار با شماره " + data.record.number + " با موفقیت ذخیره شد.");

                        if (this.state.refreshCallerAfterSave)
                            this.state.caller.refreshData(null, "list", "json", (this.state.data.record.id === this.getDefaultGuid() ? true : false));

                        this.closeMe();
                    }
                    if (this.state.data.record.io == 1) {
                        this.showSuccessMessage("رسید انبار با شماره " + data.record.number + " با موفقیت ذخیره شد.");

                        if (this.state.refreshCallerAfterSave)
                            this.state.caller.refreshData(null, "list", "json", (this.state.data.record.id === this.getDefaultGuid() ? true : false));

                        this.closeMe();
                    }
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    getBlankRow(defaultIndex = null) {
        return {
            id: this.uuidv4(),
            index: (defaultIndex == null ? this.state.data.bodies.length + 1 : defaultIndex),
            stuffId: this.defaultGuid(),
            stuffName: '',
            unitId: this.defaultGuid(),
            unitName: '',
            warehouseId: this.defaultGuid(),
            warehouseName: '',
            amount: 0,
            price: 0,
            total: 0,
            modulusCount: 0,
            modulusUnitId: this.getDefaultGuid(),
            modulusUnitName: '',
            modulusUnitRate: 0,
            warehouseLocationId: this.getDefaultGuid(),
            warehouseLocationName: '',
            ownerId: this.getDefaultGuid(),
            ownerName: '',
            realTimeInventory: 0
        };
    }
    addBlankRow() {
        this.state.data.bodies.push(this.getBlankRow());
    }
    removeRow(id) {
        this.resetRefs();
        var temp = [];
        var index = 1;
        this.state.data.bodies.sort((a, b) => a.index - b.index).forEach(r => {
            if (r.id != id) {
                temp.push(r);
                temp[temp.length - 1].index = index;
                index++;
            }
        });
        this.state.data.bodies = temp;
        this.updateFormula();
    }
    copyRow(id) {
        this.resetRefs();
        var clone = null;
        this.state.data.bodies.forEach(i => {
            if (i.id === id) {
                clone = Object.assign({}, i);
            }
        });
        clone.id = this.uuidv4();
        var startIndex = clone.index;
        for (var i = 0; i < this.state.data.bodies.length; i++) {
            if (this.state.data.bodies[i].index > startIndex) this.state.data.bodies[i].index++;
        }
        clone.index++;
        this.state.data.bodies.push(clone);
        this.updateFormula();
    }
    upIndex(id) {
        this.resetRefs();
        var idIndex = -1;
        this.state.data.bodies.forEach((r, index) => {
            if (r.id == id) idIndex = index;
        });
        if (idIndex != -1 && idIndex > 0) {
            var ii = this.state.data.bodies[idIndex].index;
            this.state.data.bodies[idIndex].index = ii - 1;
            this.state.data.bodies[idIndex - 1].index = ii;
            this.setState({ data: this.state.data });
        }
    }
    downIndex(id) {
        this.resetRefs();
        var idIndex = -1;
        this.state.data.bodies.forEach((r, index) => {
            if (r.id == id) idIndex = index;
        });
        if (idIndex != -1 && idIndex < this.state.data.bodies.length - 1) {
            var ii = this.state.data.bodies[idIndex].index;
            this.state.data.bodies[idIndex].index = ii + 1;
            this.state.data.bodies[idIndex + 1].index = ii;
            this.setState({ data: this.state.data });
        }
    }
    updateModulusCount(i) {
        this.state.data.bodies[i]['modulusCount'] = (this.state.data.bodies[i]['amount'] * this.state.data.bodies[i]['modulusUnitRate']);
    }
    updateMainCount(i) {
        if (this.state.data.bodies[i]['modulusUnitRate'] === 0) this.state.data.bodies[i]['amount'] = 0;
        else this.state.data.bodies[i]['amount'] = this.FixedPointNumber((this.state.data.bodies[i]['modulusCount'] / this.state.data.bodies[i]['modulusUnitRate']), 3);
    }
    updateRealTimeInventory(bodyItem) {
        this.state.data.bodies.forEach(f => {
            if (f.id == bodyItem.id) {
                this.getStuffInventory([
                    {
                        stuffId: bodyItem.stuffId,
                        warehouseId: bodyItem.warehouseId,
                        ownerId: bodyItem.ownerId,
                        warehouseLocationId: bodyItem.warehouseLocationId
                    }
                ]).then(records => f.realTimeInventory = records[0]);
            }
        })
    }
    setBodyValue(id, field, value, rowIndex = 0, columnIndex = 0) {
        for (var i = 0; i < this.state.data.bodies.length; i++) {
            if (this.state.data.bodies[i].id === id) {
                if (field == 'stuffId' || field == 'warehouseId' || field == 'unitId' ||
                    field == 'warehouseLocationId' ||
                    field == 'ownerId') {
                    if (field == 'stuffId') {
                        this.state.data.bodies[i][field] = value.value;
                        this.state.data.bodies[i]['amount'] = value.defaultAmount;
                        this.state.data.bodies[i]['unitId'] = value.unitId;
                        this.state.data.bodies[i]['unitName'] = value.unitName;
                        this.state.data.bodies[i]['taxRate'] = value.taxRate;
                        if (!this.feeFromTotal()) {
                            this.state.data.bodies[i]['price'] = value.price;
                        }
                        this.state.data.bodies[i]["stuffName"] = value.label;
                        this.state.data.bodies[i]['modulusUnitId'] = value.modulusUnitId;
                        this.state.data.bodies[i]['modulusUnitName'] = value.modulusUnitName;
                        this.state.data.bodies[i]['modulusUnitRate'] = value.modulusUnitRate;
                        this.updateModulusCount(i);
                    }
                    if (field == 'warehouseId') {
                        this.state.data.bodies[i][field] = value.value;
                        this.state.data.bodies[i]["warehouseName"] = value.label;
                    }
                    if (field == 'warehouseLocationId') {
                        this.state.data.bodies[i][field] = value.value;
                        this.state.data.bodies[i]['warehouseLocationName'] = value.label;
                    }
                    if (field == 'ownerId') {
                        this.state.data.bodies[i][field] = value.value;
                        this.state.data.bodies[i]['ownerName'] = value.label;
                    }
                    if (field == 'unitId') {
                        this.state.data.bodies[i][field] = value.value;
                        this.state.data.bodies[i]["unitName"] = value.label;
                    }

                    if (field == 'stuffId' || field == 'warehouseId' || field == 'warehouseLocationId' || field == 'ownerId') {
                        this.updateRealTimeInventory(this.state.data.bodies[i]);
                    }

                }
                else {
                    this.state.data.bodies[i][field] = value;
                }

                if (this.isBlank(this.state.data.bodies[i]["amount"])) this.state.data.bodies[i]["amount"] = 0;
                if (this.isBlank(this.state.data.bodies[i]["price"])) this.state.data.bodies[i]["price"] = 0;
                if (this.isBlank(this.state.data.bodies[i]["total"])) this.state.data.bodies[i]["total"] = 0;

                if (field == 'amount') {
                    this.updateModulusCount(i);
                }
                if (field == 'modulusCount') {
                    if (this.state.data.global.company.preventChangeMainUnitByModuluse === false) {
                        this.updateMainCount(i);
                    }
                }

                if (this.feeFromTotal()) {
                    if (field == 'amount' || field == 'total' || field == 'modulusCount') {
                        if (this.state.data.factorValueBy == 'sub_unit') {
                            if (this.state.data.bodies[i]["modulusCount"] === 0 || this.isBlank(this.state.data.bodies[i]["modulusCount"]))
                                this.state.data.bodies[i]["price"] = 0;
                            else
                                this.state.data.bodies[i]["price"] = this.FixedPointNumber(parseInt((this.state.data.bodies[i]["total"] / this.state.data.bodies[i]["modulusCount"])), 0);
                        }
                        else {
                            if (this.state.data.bodies[i]["amount"] === 0 || this.isBlank(this.state.data.bodies[i]["amount"]))
                                this.state.data.bodies[i]["price"] = 0;
                            else
                                this.state.data.bodies[i]["price"] = this.FixedPointNumber(parseInt((this.state.data.bodies[i]["total"] / this.state.data.bodies[i]["amount"])), 0);
                        }
                    }
                }

                if (!this.feeFromTotal()) {
                    if (this.state.data.factorValueBy == 'sub_unit') {
                        this.state.data.bodies[i]['total'] = parseInt(this.FixedPointNumber((this.state.data.bodies[i]['modulusCount'] * this.state.data.bodies[i]['price']), 0));
                    }
                    else {
                        this.state.data.bodies[i]['total'] = this.FixedPointNumber(this.state.data.bodies[i]['price'] * this.state.data.bodies[i]['amount']);
                    }
                }
            }
        }
        this.updateFormula();

        //handle enter key op
        if (field == "stuffId" || field == "warehouseId" || field == 'unitId' || field == "warehouseLocationId" || field == "ownerId") {
            this.doEnterAfterSelect(rowIndex, columnIndex);
        }
    }
    doEnterAfterSelect(rowIndex, colIndex) {
        const row = this.inputRefs[rowIndex];
        const colCount = row.length;
        const rowCount = this.inputRefs.length;

        if (colCount <= colIndex && rowCount <= rowIndex) return;

        if (colIndex + 1 < colCount) {
            //find first next active input
            if (!row[colIndex + 1]) {
                this.doEnterAfterSelect(rowIndex, colIndex + 1);
            }
            else {
                row[colIndex + 1]?.focus();
                if (row[colIndex + 1]?.type === "text") row[colIndex + 1]?.select();
            }
        } else if (rowIndex + 1 < rowCount) {
            if (!this.inputRefs[rowIndex + 1][0]) {
                this.doEnterAfterSelect(rowIndex + 1, 1);
            }
            else {
                this.inputRefs[rowIndex + 1][0]?.focus();
                if (this.inputRefs[rowIndex + 1][0]?.type === "text") this.inputRefs[rowIndex + 1][0]?.select();
            }
        }
    }
    updateFormula() {
        var hasBlankRow = false;

        for (var i = 0; i < this.state.data.bodies.length; i++) {
            if (this.state.data.bodies[i].stuffId == this.defaultGuid()) hasBlankRow = true;
        }

        if (!hasBlankRow && this.state.data.record.source === 2 && !this.fromOrdering()) this.addBlankRow();

        this.setState({ date: this.state.data });
    }
    setPerson(e) {
        if (e.value == -1) {
            this.state.data.record.personId = this.defaultGuid();
            this.state.data.record.personName = '';
            this.showComponents({ component: <Person Caller={this} FromAutoComplete={true} /> });
            return;
        }
        this.state.data.record.personId = e.value;
        this.state.data.record.personName = e.label;
        this.setState({ data: this.state.data });
    }
    onEditPerson(id) {
        this.showComponents({ component: <Person Caller={this} Id={id} FromAutoComplete={true} /> });
    }
    setType(e) {
        this.state.data.record.type = parseInt(e.target.value);
        this.setState({ data: this.state.data });
    }
    inputByBarcode(e) {
        e.preventDefault();
        this.sendBarCode(this.state.barcode);
    }
    sendBarCode(barcode) {
        if (!this.isBlank(barcode)) {
            this.httpPost("api/v1/stuff/get/barcode/", {
                barcode: barcode,
            })
                .then(data => {
                    if (data.status === 1) {
                        this.state.barcode = '';

                        if (!this.isNull(data.record)) {
                            var itemId = null;

                            for (var i = 0; i < this.state.data.bodies.length; i++) {
                                if (this.state.data.bodies[i].stuffId == this.defaultGuid())
                                    itemId = this.state.data.bodies[i].id;
                            }

                            this.setBodyValue(itemId, 'stuffId', data.record);
                        }
                    }
                    this.setState({
                        loading: false
                    });
                });
        }
    }
    getBodySum(f) {
        var sum = 0;
        this.state.data.bodies.forEach(body => {
            sum += body[f];
        });
        return sum
    }
    //override
    remove() {
        var id = this.state.id_to_remove;
        if (this.isNull(id) && !this.isNull(this.state.selectedIds)) id = this.state.selectedIds;

        this.httpPost("api/v1/" + this.state.controllerName + "/remove", {
            id,
            companyId: this.state.data.global.company.id,
            organizationId: this.state.data.global.company.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت حذف گردید");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({ showConfirmRemove: false });
                }
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    fromOrdering() {
        if (!this.isBlank(this.state.data.record.orderingId) && this.state.data.record.orderingId !== this.getDefaultGuid()) return true;
        return false;
    }
    pickAttachmentFile() {
        document.getElementById('attachFilePicker').click();
    }
    uploadAttachment(_file) {
        var th = this;
        this.lockScreen();
        this.getBase64(_file).then(file => {
            var pic = file;
            var picFileName = _file.name;

            th.httpPost("api/v1/remittance/upload", {
                pic,
                picFileName,
            })
                .then(data => {
                    if (data.status === -1) window.location.href = "/login";
                    if (data.status === 1) {
                        th.setAttachmentValue(data.record);
                        document.getElementById('attachFilePicker').value = null;
                    }
                    else {
                        th.showErorrMessage(data.message);
                    }
                    th.setState({
                        loading: false
                    });
                });
        });
    }
    removeAttachment(id) {
        var temp = [];
        this.state.data.attachments.forEach(f => {
            if (f.id !== id) {
                temp.push(f);
            }
        });
        this.state.data.attachments = temp;
        this.setState({ data: this.state.data });
    }
    setAttachmentValue(record) {
        this.state.data.attachments.push(record);
        this.setState({ data: this.state.data });
    }
    renderBody() {
        var trs = [];
        this.state.data.bodies.sort((a, b) => a.index - b.index).forEach((item, index) => {
            var tds = [];
            var refColumnIndex = 0;

            tds.push(<td>
                <span className="inGridRowNumber">{(index + 1)}</span>
                <div style={{ "font-size": "9pt", "color": "silver" }}>
                    {index > 0 && index != this.state.data.bodies.length - 1 && <span onClick={e => this.upIndex(item.id)} className="fa fa-arrow-up move-up" title="انتقال به بالا"></span>}
                    {index < this.state.data.bodies.length - 2 && <span onClick={e => this.downIndex(item.id)} className="fa fa-arrow-down move-down" title="انتقال به پایین"></span>}
                </div>
            </td>);

            if (!this.fromOrdering && this.state.data.record.source === 2) {
                let _refColumnIndexC1 = refColumnIndex;
                tds.push(<td key={"stuff_" + item.stuffId}>
                    <SelectAsync
                        defaultValue={item.stuffId != this.defaultGuid() ? [{ value: item.stuffId, label: item.stuffName }] : null}
                        isMulti={false}
                        placeholder="انتخاب"
                        noOptionsMessage={({ inputValue }) =>
                            inputValue ? "نتیجه‌ای یافت نشد" : null
                        }
                        defaultOptions={[]}
                        components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null,
                        }}
                        loadOptions={this.loadStuffsOptions}
                        onChange={e => this.setBodyValue(item.id, 'stuffId', e, index, _refColumnIndexC1)}
                        ref={(el) => {
                            if (!this.inputRefs[index])
                                this.inputRefs[index] = [];
                            this.inputRefs[index][_refColumnIndexC1] = el;
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp") {
                                const select = this.inputRefs[index][_refColumnIndexC1];
                                if (this.isNull(select.state.focusedOptionId)) this.handleKeyDown(index, _refColumnIndexC1, e);
                            }
                        }}
                    />
                </td>);
                refColumnIndex++;
            }
            else {
                tds.push(<td>{item.stuffName}</td>);
            }

            if (this.state.data.global.company.enableWarehouseLocation === true) {
                let _refColumnIndexC2 = refColumnIndex;

                if (this.state.data.record.source === 2) {
                    tds.push(<td key={"warehouseLocation_" + item.warehouseLocationId}>
                        {this.state.data.record.warehouseId != this.defaultGuid() && <SelectAsync
                            defaultValue={
                                item.warehouseLocationId != this.defaultGuid()
                                    ? [
                                        {
                                            value: item.warehouseLocationId,
                                            label: item.warehouseLocationName,
                                        },
                                    ]
                                    : null
                            }
                            isMulti={false}
                            placeholder="انتخاب"
                            noOptionsMessage={({ inputValue }) =>
                                inputValue ? "نتیجه‌ای یافت نشد" : null
                            }
                            components={{
                                DropdownIndicator: () => null,
                                IndicatorSeparator: () => null,
                            }}
                            defaultOptions={[]}
                            loadOptions={(inputValue, callback) => this.loadWarehouseLocationsOptions(inputValue, callback, this.state.data.record.warehouseId)}
                            onChange={(e) => this.setBodyValue(item.id, 'warehouseLocationId', e, index, _refColumnIndexC2)}
                            ref={(el) => {
                                if (!this.inputRefs[index])
                                    this.inputRefs[index] = [];
                                this.inputRefs[index][_refColumnIndexC2] = el;
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp") {
                                    const select = this.inputRefs[index][_refColumnIndexC2];
                                    if (this.isNull(select.state.focusedOptionId)) this.handleKeyDown(index, _refColumnIndexC2, e);
                                }
                            }}
                        />}
                    </td>);
                }
                else {
                    tds.push(<td>{item.warehouseLocationName}</td>);
                }
                refColumnIndex++;
            }

            if (this.state.data.global.company.enableWarehouseOwner === true) {
                let _refColumnIndexC3 = refColumnIndex;
                if (this.state.data.record.source === 2) {
                    tds.push(<td key={"owner_" + item.ownerId}>
                        <SelectAsync
                            defaultValue={
                                item.ownerId != this.defaultGuid()
                                    ? [
                                        {
                                            value: item.ownerId,
                                            label: item.ownerName,
                                        },
                                    ]
                                    : null
                            }
                            isMulti={false}
                            placeholder="انتخاب"
                            noOptionsMessage={({ inputValue }) =>
                                inputValue ? "نتیجه‌ای یافت نشد" : null
                            }
                            components={{
                                DropdownIndicator: () => null,
                                IndicatorSeparator: () => null,
                            }}
                            defaultOptions={[]}
                            loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback)}
                            onChange={(e) => this.setBodyValue(item.id, 'ownerId', e, index, _refColumnIndexC3)}
                            ref={(el) => {
                                if (!this.inputRefs[index])
                                    this.inputRefs[index] = [];
                                this.inputRefs[index][_refColumnIndexC3] = el;
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp") {
                                    const select = this.inputRefs[index][_refColumnIndexC3];
                                    if (this.isNull(select.state.focusedOptionId)) this.handleKeyDown(index, _refColumnIndexC3, e);
                                }
                            }}
                        />
                    </td>);
                }
                else {
                    tds.push(<td>{item.ownerName}</td>);
                }
                refColumnIndex++;
            }

            if (this.state.data.record.source === 2) {
                let _refColumnIndexC4 = refColumnIndex;
                tds.push(<td style={{ "width": "80px" }}>
                    <NumberFormat value={item.amount} onChange={e => this.setBodyValue(item.id, 'amount', parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''}
                        className='form-control text-center ltr'
                        getInputRef={(el) => {
                            if (!this.inputRefs[index]) this.inputRefs[index] = [];
                            this.inputRefs[index][_refColumnIndexC4] = el;
                        }}
                        onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC4, e)} />
                </td>);
                refColumnIndex++;
            }
            else {
                tds.push(<td>{item.amount}</td>);
            }

            tds.push(<td>{item.unitName}</td>);

            if (this.state.data.companySetting.stuffSubUnitEnable === 2) {
                if (this.state.data.record.source === 2) {
                    let _refColumnIndexC5 = refColumnIndex;
                    tds.push(<td style={{ "width": "80px" }}>
                        <NumberFormat value={item.modulusCount} onChange={e => this.setBodyValue(item.id, 'modulusCount', parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''}
                            className='form-control text-center ltr'
                            getInputRef={(el) => {
                                if (!this.inputRefs[index]) this.inputRefs[index] = [];
                                this.inputRefs[index][_refColumnIndexC5] = el;
                            }}
                            onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC5, e)} />
                    </td>);
                    refColumnIndex++;
                }
                else {
                    tds.push(<td>{item.modulusCount}</td>);
                }
            }

            if (this.state.data.companySetting.stuffSubUnitEnable === 2) {
                tds.push(<td>{item.modulusUnitName}</td>);
            }

            if (this.state.data.record.io !== 3) {
                let _refColumnIndexC6 = refColumnIndex;
                tds.push(<td style={{ "width": "120px" }}>
                    <NumberFormat value={item.price}
                        disabled={this.feeFromTotal()}
                        onChange={e => this.setBodyValue(item.id, 'price', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''}
                        className='form-control text-center ltr'
                        getInputRef={(el) => {
                            if (!this.inputRefs[index]) this.inputRefs[index] = [];
                            this.inputRefs[index][_refColumnIndexC6] = el;
                        }}
                        onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC6, e)} />
                </td>);
                refColumnIndex++;
            }

            if (this.state.data.record.io !== 3) {
                tds.push(<td style={{ "width": "120px" }}>
                    <NumberFormat
                        disabled={!this.feeFromTotal()}
                        onChange={e => this.setBodyValue(item.id, 'total', parseInt(e.target.value.replace(/,/g, '')))}
                        value={item.total}
                        thousandSeparator={true}
                        prefix={''}
                        className='form-control text-center ltr' />
                </td>);
            }

            if (this.state.data.record.io !== 3) {
                tds.push(<td style={{ "width": "120px" }}>
                    {this.FixedPointNumber(item.realTimeInventory, 3)}
                </td>);
            }

            if (!this.fromOrdering() && this.state.data.record.source === 2) {
                tds.push(<td>
                    {item.stuffId != this.defaultGuid() && <span title="حذف سطر" onClick={e => this.removeRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>}
                    {item.stuffId != this.defaultGuid() && <span title="کپی سطر" onClick={e => this.copyRow(item.id)} className="fa fa-copy fa-fw close-grid-row"></span>}
                </td>);
            }

            trs.push(<tr key={item.id} id={(this.state.highlightedStuffs.includes(item.stuffId) ? "highlightedStuffs_" + item.stuffId : "")} className={(this.state.highlightedStuffs.includes(item.stuffId) ? "highlighted" : "")}>{tds}</tr>);
        });

        return <tbody>{trs}</tbody>
    }
    setManualFactor(e) {
        this.state.data.record.manualFactor = e.target.value === "1";
        this.setState({ data: this.state.data });
    }
    setFactor(e) {
        this.state.data.bodies = [];
        if (e == null) {
            this.state.data.record.factorId = null;
            this.state.data.record.factorNumber = '';
        }
        else {
            this.state.data.record.factorId = e.value;
            this.state.data.record.factorNumber = e.label;

            this.httpPost("api/v1/factor/get", {
                id: this.state.data.record.factorId,
                includeCostPrice: true
            })
                .then(data => {
                    if (data.status === -1) window.location.href = "/login";
                    if (data.status === 1) {
                        for (var i = 0; i < data.record.items.length; i++) {
                            this.addBlankRow();
                            var lastIndex = this.state.data.bodies.length - 1;

                            this.state.data.bodies[lastIndex].id = data.record.items[i].id;
                            this.state.data.bodies[lastIndex].index = data.record.items[i].index;
                            this.state.data.bodies[lastIndex].stuffId = data.record.items[i].stuffId;
                            this.state.data.bodies[lastIndex].stuffName = data.record.items[i].stuffName;
                            this.state.data.bodies[lastIndex].unitId = data.record.items[i].unitId;
                            this.state.data.bodies[lastIndex].unitName = data.record.items[i].unitName;
                            this.state.data.bodies[lastIndex].warehouseId = data.record.items[i].warehouseId;
                            this.state.data.bodies[lastIndex].warehouseName = data.record.items[i].warehouseName;
                            this.state.data.bodies[lastIndex].count = data.record.items[i].amount;
                            this.state.data.bodies[lastIndex].price = data.record.items[i].finalCostPrice;
                            this.state.data.bodies[lastIndex].total = this.FixedPointNumber(data.record.items[i].amount * data.record.items[i].finalCostPrice, 0);
                            this.state.data.bodies[lastIndex].modulusCount = data.record.items[i].modulusCount;
                            this.state.data.bodies[lastIndex].modulusUnitId = data.record.items[i].modulusUnitId;
                            this.state.data.bodies[lastIndex].modulusUnitName = data.record.items[i].modulusUnitName;
                            this.state.data.bodies[lastIndex].modulusUnitRate = data.record.items[i].modulusUnitRate;
                            this.state.data.bodies[lastIndex].warehouseLocationId = data.record.items[i].warehouseLocationId;
                            this.state.data.bodies[lastIndex].warehouseLocationName = data.record.items[i].warehouseLocationName;
                            this.state.data.bodies[lastIndex].ownerId = data.record.items[i].ownerId;
                            this.state.data.bodies[lastIndex].ownerName = data.record.items[i].ownerName;
                            this.state.data.bodies[lastIndex].realTimeInventory = 0;
                        }

                        for (var i = 0; i < this.state.data.bodies.length; i++)
                            this.updateRealTimeInventory(this.state.data.bodies[i]);
                    }
                    else {
                        this.showErorrMessage(data.message);
                    }
                });
        }

        this.state.loading = false;
        this.updateFormula();
        this.setState({ data: this.state.data });
    }
    feeFromTotal() {
        if (this.state.data.record.type === 5) return true;
        else return false;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="panel panel-info center-block" style={{ "max-width": "none", "border": "none" }} >
                            <div className="modal-header modal-header-info" style={{ "padding": "0px" }} >
                                <button type="button" className="close" aria-label="Close" onClick={e => this.closeMe()}><span aria-hidden="true">×</span></button>
                                <h4 class="modal-title"><span>
                                    {this.state.data.record.io == 1 && <span>رسید انبار</span>}
                                    {this.state.data.record.io == 2 && <span>حواله انبار</span>}
                                    {this.state.data.record.io == 3 && <span>جابجایی بین انبار</span>}
                                </span></h4></div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <ul className="nav nav-tabs mt-n3">
                                        <li className="nav-item">
                                            <a id="letterInfoTab" className="nav-link active" data-bs-toggle="tab" href="#info"><span>اقلام</span></a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" data-bs-toggle="tab" href="#attachment"><span>پیوستها</span></a>
                                        </li>
                                        {this.state.data.record.id !== this.getDefaultGuid() && <li className="nav-item">
                                            <a className="nav-link" data-bs-toggle="tab" href="#workflow"><span>گردش کار</span></a>
                                        </li> }
                                    </ul>
                                    <div className="tab-content">
                                        <div className="tab-pane active" id="info">
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        {this.state.data.record.io !== 3 && <label for="invoiceDate" className="title1">انبار <span className="red">*</span></label>}
                                                        {this.state.data.record.io === 3 && <label for="invoiceDate" className="title1">انبار مبدا <span className="red">*</span></label>}
                                                        {this.state.data.record.source !== 2 ? <span>{this.state.data.record.warehouseName}</span>
                                                            :
                                                            <SelectAsync
                                                                defaultValue={this.state.data.record.warehouseId != this.defaultGuid() ? [{ value: this.state.data.record.warehouseId, label: this.state.data.record.warehouseName }] : null}
                                                                isMulti={false}
                                                                placeholder="انتخاب انبار"
                                                                noOptionsMessage={({ inputValue }) => inputValue ? "نتیجه‌ای یافت نشد" : null}
                                                                defaultOptions={[]}
                                                                components={{
                                                                    DropdownIndicator: () => null,
                                                                    IndicatorSeparator: () => null,
                                                                }}
                                                                loadOptions={(inputValue, callback) => this.loadWarehousesOptions(inputValue, callback, 'remittance')}
                                                                onChange={e => {
                                                                    this.state.data.record.warehouseId = e.value;
                                                                    this.state.data.record.warehouseName = e.label;

                                                                    for (var i = 0; i < this.state.data.bodies.length; i++) {
                                                                        this.state.data.bodies[i]['warehouseLocationId'] = this.getDefaultGuid();
                                                                        this.state.data.bodies[i]['warehouseLocationName'] = '';
                                                                    }

                                                                    this.setState({ data: this.state.data });
                                                                }
                                                                }
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                                {this.state.data.record.io === 3 && <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label for="invoiceDate" className="title1">انبار مقصد <span className="red">*</span></label>
                                                        <SelectAsync
                                                            defaultValue={this.state.data.record.warehouseId2 != this.defaultGuid() ? [{ value: this.state.data.record.warehouseId2, label: this.state.data.record.warehouseName2 }] : null}
                                                            isMulti={false}
                                                            placeholder="انتخاب انبار"
                                                            noOptionsMessage={({ inputValue }) =>
                                                                inputValue ? "نتیجه‌ای یافت نشد" : null
                                                            }
                                                            defaultOptions={[]}
                                                            components={{
                                                                DropdownIndicator: () => null,
                                                                IndicatorSeparator: () => null,
                                                            }}
                                                            loadOptions={(inputValue, callback) => this.loadWarehousesOptions(inputValue, callback, 'remittance')}
                                                            onChange={e => {
                                                                this.state.data.record.warehouseId2 = e.value
                                                                this.state.data.record.warehouseName2 = e.label
                                                            }
                                                            }
                                                        />
                                                    </div>
                                                </div>}
                                                {this.state.data.record.io == 1 &&
                                                    <div className="col-sm-3">
                                                        <div className="form-group">
                                                            <label for="invoiceDate" className="title1">معین طرف حساب <span className="red">*</span></label>
                                                            {this.state.data.record.source !== 2 ? <span>{this.state.data.record.personMoeinName}</span>
                                                                :
                                                                <SelectAsync
                                                                    style={{ "width": "100%" }}
                                                                    defaultValue={this.state.data.record.personMoeinAccountId !== this.getDefaultGuid() ? [{ value: this.state.data.record.personMoeinAccountId, label: this.state.data.record.personMoeinName }] : null}
                                                                    isMulti={false}
                                                                    placeholder="انتخاب معین طرف حساب"
                                                                    noOptionsMessage={({ inputValue }) =>
                                                                        inputValue ? "نتیجه‌ای یافت نشد" : null
                                                                    }
                                                                    defaultOptions={[]}
                                                                    components={{
                                                                        DropdownIndicator: () => null,
                                                                        IndicatorSeparator: () => null,
                                                                    }}
                                                                    loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3)}
                                                                    onChange={e => this.state.data.record.personMoeinAccountId = e.value}
                                                                />
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                {(!this.fromOrdering() && (this.state.data.record.io !== 3 && this.state.data.record.type !== 5)) && <div className="col-sm-3">
                                                    <div className="form-group">
                                                        {this.state.io == 1 && <label for="invoiceContact" className="title1">تامین کننده<span className="red">*</span></label>}
                                                        {this.state.io == 2 && <label for="invoiceContact" className="title1">مشتری<span className="red">*</span></label>}
                                                        <div id="displayPersonBalance" style={{ "display": "inline-block" }} ></div>
                                                        [
                                                        <em className="icon ni ni-plus hand ms-1" onClick={e => this.setPerson({ value: -1 })}></em>
                                                        {!this.isNull(this.state.data.record.personId) && this.state.data.record.personId != this.defaultGuid() && <em onClick={e => this.onEditPerson(this.state.data.record.personId)} className="icon ni ni-pen hand ms-1"></em>}
                                                        {this.state.data.record.source !== 2 ? <span>{this.state.data.record.personName}</span>
                                                            :
                                                            <SelectAsync
                                                                value={!this.isNull(this.state.data.record.personId) && this.state.data.record.personId != this.defaultGuid() ? [{ value: this.state.data.record.personId, label: this.state.data.record.personName }] : null}
                                                                isMulti={false}
                                                                placeholder="انتخاب ..."
                                                                noOptionsMessage={({ inputValue }) =>
                                                                    inputValue ? "نتیجه‌ای یافت نشد" : null
                                                                }
                                                                defaultOptions={[]}
                                                                components={{
                                                                    DropdownIndicator: () => null,
                                                                    IndicatorSeparator: () => null,
                                                                }}
                                                                loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1, (this.state.io == 1 ? 2 : 1))}
                                                                onChange={e => this.setPerson(e)}
                                                            />
                                                        }
                                                    </div>
                                                </div>}

                                                {this.state.data.record.automatic === false && <div className="col-sm-2">
                                                    <div className="form-group">
                                                        <label for="invoiceDate" className="title1">تاریخ<span className="red">*</span></label>
                                                        {this.state.enableDatePicker === true ? <DatePicker
                                                            inputReadOnly={true}
                                                            className="form-control input-sm persian-date"
                                                            placeholder={"تاریخ"}
                                                            isGregorian={false}
                                                            showTodayButton={true}
                                                            timePicker={false}
                                                            onChange={(e) => { this.state.data.record.date = e }}
                                                            value={this.getFormatedDateForDatePicker(this.state.data.record.date)}
                                                        /> :
                                                            <input
                                                                onChange={(e) => this.state.data.record.date = e.target.value}
                                                                defaultValue={this.state.data.record.date}
                                                                autoComplete="off"
                                                                placeholder={'تاریخ'}
                                                                type="text"
                                                                className="form-control ltr"
                                                                maxLength="10"
                                                            />}
                                                    </div>
                                                </div>}
                                                <div className="col-sm-2">
                                                    <div className="form-group">
                                                        <label className="title1">شماره</label>
                                                        {this.state.data.record.source !== 2 ? <span>{this.state.data.record.number}</span>
                                                            :
                                                            <NumberFormat value={this.state.data.record.number} onChange={e => this.state.data.record.number = parseInt(e.target.value.replace(/,/g, ''))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
                                                        }
                                                    </div>
                                                </div>

                                                {(!this.fromOrdering() && this.state.data.record.io === 1) && this.state.data.record.automatic === false && <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label className="title1">نوع</label>
                                                        <select className="form-control text-center" defaultValue={this.state.data.record.type} onChange={e => this.setType(e)}>
                                                            <option value="1">خرید</option>
                                                            <option value="4">برگشت از فروش</option>
                                                            <option value="5">موجودی اول دوره</option>
                                                            <option value="7">تولید</option>
                                                            <option value="9">ضایعات</option>
                                                            <option value="10">اضافات</option>
                                                            <option value="12">امانی</option>
                                                            <option value="14">خرید خارجی</option>
                                                            <option value="15">خرید ملزومات</option>
                                                            <option value="16">دارایی ثابت</option>
                                                        </select>
                                                    </div>
                                                </div>}
                                                {(!this.fromOrdering() && this.state.data.record.io === 2) && this.state.data.record.automatic === false && <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label className="title1">نوع</label>
                                                        <select className="form-control text-center" defaultValue={this.state.data.record.type} onChange={e => this.setType(e)}>
                                                            <option value="2">فروش</option>
                                                            <option value="3">برگشت از خرید</option>
                                                            <option value="6">مصرف</option>
                                                            <option value="11">کسورات</option>
                                                            <option value="13">امانی</option>
                                                            <option value="17">فروش - دفتر دریافت</option>
                                                        </select>
                                                    </div>
                                                </div>}

                                                {(!this.fromOrdering() && this.state.data.record.io === 3) && <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label className="title1">نوع</label>
                                                        <select className="form-control text-center" defaultValue={this.state.data.record.type} onChange={e => this.setType(e)}>
                                                            <option value="8">بین انبار</option>
                                                        </select>
                                                    </div>
                                                </div>}

                                                {this.state.data.record.automatic === false && (this.state.data.record.type === 1 || this.state.data.record.type === 14 || this.state.data.record.type === 2) && <div className="col-sm-1">
                                                    <div className="form-group">
                                                        <label className="title1">صدور فاکتور</label>
                                                        <select onChange={(e) => this.setManualFactor(e)}
                                                            defaultValue={this.state.data.record.manualFactor ? "1" : "0"} autoComplete="off" className="form-control">
                                                            <option value="0">خودکار</option>
                                                            <option value="1">دستی</option>
                                                        </select>
                                                    </div>
                                                </div>}

                                                {this.state.data.record.manualFactor === true &&
                                                    (this.state.data.record.type === 1 || this.state.data.record.type === 14 || this.state.data.record.type === 2) && <div className="col-sm-1">
                                                        <label className="form-label required">فاکتور دستی </label>
                                                        <SelectAsync
                                                            defaultValue={
                                                                (!this.isNull(this.state.data.record.factorId) && this.state.data.record.factorId != this.defaultGuid())
                                                                    ? [
                                                                        {
                                                                            value: this.state.data.record.factorId,
                                                                            label: this.state.data.record.factorNumber,
                                                                        },
                                                                    ]
                                                                    : null
                                                            }
                                                            isMulti={false}
                                                            placeholder="انتخاب فاکتور دستی"
                                                            noOptionsMessage={({ inputValue }) =>
                                                                inputValue ? "نتیجه‌ای یافت نشد" : null
                                                            }
                                                            components={{
                                                                DropdownIndicator: () => null,
                                                                IndicatorSeparator: () => null,
                                                            }}
                                                            defaultOptions={[]}
                                                            loadOptions={(inputValue, callback) => this.loadFactorsOptions(inputValue, callback, ((this.state.data.record.type === 1 || this.state.data.record.type === 14) ? [1,6] : this.state.data.record.type === 2 ? 2 : 0), 1)}
                                                            onChange={(e) => this.setFactor(e)}
                                                        />
                                                    </div>}

                                            </div>
                                            <div className="row mt-2 mb-2">
                                                {(!this.fromOrdering() && this.state.data.record.source === 2) && <div className="col-md-4">
                                                    <label className="title1">ورود بارکدخوان</label>
                                                    <form key={"barcode_" + this.state.barcode} onSubmit={e => this.inputByBarcode(e)}>
                                                        <input autocomplete="off" onChange={e => this.state.barcode = e.target.value} defaultValue={this.state.barcode} type="text" placeholder="بارکد کالا ..." className="form-control ltr" style={{ "width": "100%" }} maxlength="150" />
                                                        <input autocomplete="off" type="submit" className="hidden" />
                                                    </form>
                                                </div>}
                                                <div className="col-md-8">
                                                    <label className="title1">شرح</label>
                                                    <input className="form-control" type="text" defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} />
                                                </div>
                                            </div>
                                            <table className="table table-bordered acc_grid_row">
                                                <thead>
                                                    <tr className="active">
                                                        <th style={{ "width": "30px" }}>#</th>
                                                        <th style={{ minWidth: "200px" }}>کالا<span className="red">*</span></th>
                                                        {this.state.data.global.company.enableWarehouseLocation === true && <th style={{ minWidth: "150px" }}>جایگاه</th>}
                                                        {this.state.data.global.company.enableWarehouseOwner === true && <th style={{ minWidth: "150px" }}>مالک</th>}
                                                        <th style={{ width: '60px' }}>تعداد/مقدار<span className="red">*</span></th>
                                                        <th style={{ "width": "45px" }}>واحد اصلی<span className="red">*</span></th>
                                                        {this.state.data.companySetting.stuffSubUnitEnable === 2 && <th style={{ "width": "60px" }}>
                                                            <span>تعداد/مقدار<br />فرعی</span>
                                                        </th>}
                                                        {this.state.data.companySetting.stuffSubUnitEnable === 2 && <th style={{ width: '45px' }}>واحد فرعی</th>}
                                                        {this.state.data.record.io !== 3 && <th style={{ "width": "90px" }}>مبلغ واحد<br /><span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span><span className="red">*</span></th>}
                                                        {this.state.data.record.io !== 3 && <th style={{ "width": "120px" }}>جمع کل<br /><span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></th>}
                                                        {this.state.data.record.io !== 3 && <th style={{ "width": "50px" }}>موجودی<br />فعلی</th>}
                                                        {(!this.fromOrdering() && this.state.data.record.source === 2) && <th style={{ "width": "35px" }}></th>}
                                                    </tr>
                                                </thead>
                                                {this.renderBody()}
                                                <tfoot style={{ "backgroundColor": "whitesmoke" }}>
                                                    <tr className="active">
                                                        <td className="text-center" colSpan="2"><span>مجموع</span></td>
                                                        {this.state.data.global.company.enableWarehouseLocation === true && <td></td>}
                                                        {this.state.data.global.company.enableWarehouseOwner === true && <td></td>}
                                                        <td className="text-center" style={{ "width": "120px" }}>{this.getBodySum('amount')}</td>
                                                        <td></td>
                                                        {this.state.data.companySetting.stuffSubUnitEnable === 2 && <td className="text-center" style={{ "width": "80px" }}></td>}
                                                        {this.state.data.companySetting.stuffSubUnitEnable === 2 && <td className="text-center"></td>}
                                                        {this.state.data.record.io !== 3 && <td className="text-center" style={{ "width": "120px" }}>{this.getBodySum('price')}</td>}
                                                        {this.state.data.record.io !== 3 && <td className="text-center" style={{ "width": "120px" }}>{this.getBodySum('total')}</td>}
                                                        {(!this.fromOrdering() && this.state.data.record.source === 2) && <td className="text-center" style={{ "width": "35px" }}></td>}
                                                    </tr>
                                                </tfoot>
                                            </table>
                                            <div className="row" style={{ "padding-left": "15px" }} >
                                                <div className="col-lg-12 col-md-12 col-sm-12">
                                                    <div className="row mr-t-10">
                                                        <div className="col-md-2 ltr text-right">
                                                        </div>
                                                    </div>
                                                    <div className="form-group" style={{ "padding-left": "50px" }} >
                                                        <label className="title1" for="comment">یادداشت</label>
                                                        <textarea onChange={e => this.state.data.record.note = e.target.value} defaultValue={this.state.data.record.note} className="form-control ng-pristine ng-untouched ng-valid" rows="4" maxlength="250"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="tab-pane" id="attachment">
                                            <table className="table table-bordered acc_grid_row">
                                                <thead>
                                                    <tr className="active">
                                                        <td style={{ "width": "75px" }}>مشاهده پیوست</td>
                                                        <td style={{ "width": "35px" }}></td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.data.attachments.map((item, index) =>
                                                        <tr key={item.id}>
                                                            <td>
                                                                <a href={"/api/v1/media/remittance/attachment/view/?file=" + item.fileName} target="_blank" className="me-1 text-primary hand" style={{ "display": "inline-block" }}>مشاهده</a>
                                                            </td>
                                                            <td>
                                                                <span title="حذف سطر" onClick={e => this.removeAttachment(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>
                                                            </td>
                                                        </tr>
                                                    )}
                                                    <tr>
                                                        <td colspan="4">
                                                            <a className="my-2 btn btn-primary hand" onClick={e => this.pickAttachmentFile()} style={{ "display": "inline-block" }}>افزودن فایل پیوست</a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        {this.state.data.record.id !== this.getDefaultGuid() && <div className="tab-pane" id="workflow">
                                            <WorkFlowStepLogging Caller={this} EntityId={this.state.data.record.id} WorkFlowStepId={this.state.data.record.workFlowStepId} Type={2} />
                                        </div>}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="hand btn btn-primary" onClick={e => this.save(e, false)} >ذخیره</button>
                                {this.state.data.record.io == 2 && this.isNull(this.state.data.record.documentId) && <button type="button" className="hand btn btn-warning" onClick={e => this.save(e, false)} style={{ "marginRight": "10px" }} >صدور سند</button>}
                                &nbsp;
                                {this.state.data.record.id !== this.defaultGuid() && [
                                    <a className="hand btn btn-warning" style={{ "marginRight": "10px" }} onClick={e => this.exportFromUrl('print', '/api/v1/remittance/export/' + this.state.data.record.id)}>چاپ</a>
                                    ,
                                    <a className="hand btn btn-warning" style={{ "marginRight": "10px" }} onClick={e => this.exportFromUrl('pdf', '/api/v1/remittance/export/' + this.state.data.record.id)}>PDF</a>
                                ]
                                }
                                {this.state.data.record.id !== this.defaultGuid() && <a className="btn btn-danger me-2" onClick={e => this.confirmRemove(this.state.data.record.id)} >حذف</a>}
                                <a className="btn btn-warning" style={{ "width": "80px" }} onClick={e => this.closeMe()}>انصراف</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.state.data.status === 0 ? this.apiFailInModal() : this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}